import { render, staticRenderFns } from "./monopolyDicesBalance.vue?vue&type=template&id=15dc9154"
import script from "./monopolyDicesBalance.vue?vue&type=script&lang=js"
export * from "./monopolyDicesBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports